
import React ,{useState, useCallback, useEffect} from 'react'
import styled from 'styled-components'
import { useTable } from 'react-table'
import axios from 'axios'
import {getRequest} from '../../services/axiosBaseClient'

const Styles = styled.div`
  padding: 0rem;

  table {
    border-spacing: 0;
    border: 0px solid black;
    width: 100%;
    margin: 15px 0px 25px 0px;
    tr {
      :last-child {
        td {
          border-bottom: 20px;
         
        }
      }
    }
    tr:hover { 
      background-color:#DEE2E6;
    }
    th {
      background-color: #F5F5FF;
      color: #343A40;
    }
    th,
    td { 
      padding: 15px;
      border: 3px rgb(201, 204, 216);
      border-style: solid none solid none;
      border-color:#F5F5FF;

      :last-child {
        border-right: 20px;
      }
    }
  }
`

function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })

  // Render the UI for your table
  return (
    <table {...getTableProps()}>
      <thead>
        {
        headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column,idx) => (
              // console.log(column)
              !column.hideHeader? <th {...column.getHeaderProps()}>{column.render('Header')}</th>:<></>
            ))}
          </tr>
        ))
        }
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row)
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => {
                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}



function App() {

  const [dataTable, setDataTable] = useState([])
  const getBatterySwappingHistory = useCallback(async ()=>{
    await getRequest('bss/getBatterySwapHistory?batteryId=3').then((res)=>{
      if(res && res?.data){
        setDataTable(res?.data) 
       console.log(res?.data,'Table Data----->', dataTable)
      }
    })
  }, []);
  


  useEffect(()=>{
    getBatterySwappingHistory();
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: 'A',
        hideHeader: true,
        columns: [
          {
            Header: 'Driver Name',
            accessor: 'driverName',
          },
          {
            Header: 'Vehicle ID',
            accessor: 'vehicleId',
          },
          {
            Header: 'Swap Type',
            accessor: 'swapType',
          },
          {
            Header: 'SOC %',
            accessor: 'soc',
          },
          {
            Header: 'Date-Time',
            accessor: 'swapDate',
          }
        ],
      },
    ],
    []
  )

  var data=[
    {
      soc: 10.0,
      swapDate: "2022-05-31 09:05:36.386584",
      vehicleId: 2,
      driverName: "test300",
      swapType: "Swap OUT"
    },
    {
      soc: 10.0,
      swapDate: "2022-05-31 09:05:36.386584",
      vehicleId: 2,
      driverName: "test300",
      swapType: "Swap OUT"
    }
  ];

 

  return (
    <Styles>
      <Table columns={columns} data={dataTable}/>
    </Styles>
  )
}

export default App

